<button [ngClass]="buttonClasses" [ngStyle]="extraStyles" (click)="onClick()">
  <div class="icon" *ngIf="iconName">
    <mat-icon [style.font-size]="iconSizeWithPx">{{iconName}}</mat-icon>
  </div>
  {{ label }}
</button>
